import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";
import { useAuth } from "../context/AuthContext";
import { listarParceiros, livresDoParceiro, pedirAula, minhasAulas, acaoMinhaAula } from "../services/api";
import { quando, STATUS_AULA, EscolherHorario } from "../components/AulasComum";

// 🎓 CAPACITAÇÃO (17/10/2026): vitrine de professores e escolas APROVADOS, pedido de aula grátis e "Minhas aulas".
export default function CapacitacaoPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [skill, setSkill] = useState(new URLSearchParams(location.search).get("skill") || "");
  const [parceiros, setParceiros] = useState(null);
  const [aulas, setAulas] = useState([]);
  const [pedindo, setPedindo] = useState(null);   // parceiro escolhido para pedir aula
  const [erro, setErro] = useState("");
  const [aviso, setAviso] = useState("");
  const ehCandidato = user?.tipo === 0;

  const carregarAulas = () => { if (ehCandidato) minhasAulas().then(setAulas).catch(() => {}); };
  useEffect(() => { document.title = "Aulas grátis com professores parceiros · eaiRH"; carregarAulas(); }, [user]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { listarParceiros(skill.trim() || null).then(setParceiros).catch((e) => setErro(e.message)); }, [skill]);

  const acao = async (a, nome, inicio) => {
    setErro(""); setAviso("");
    try { await acaoMinhaAula(a.id, nome, inicio); carregarAulas(); setAviso("Pronto!"); }
    catch (e) { setErro(e.message); }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-4xl mx-auto px-4 md:px-6 py-8">
        <h1 className="text-2xl md:text-3xl font-bold text-text">Aulas grátis com professores parceiros</h1>
        <p className="text-gray-600 mt-1 text-sm">Desenvolva as skills que as vagas pedem. Cada professor oferece uma aula grátis, feita aqui mesmo no eaiRH, sem instalar nada.</p>
        {erro && <p className="mt-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2">{erro}</p>}
        {aviso && <p className="mt-3 rounded-xl bg-green-50 border border-green-200 text-green-800 text-sm px-3 py-2">{aviso}</p>}

        {ehCandidato && aulas.length > 0 && (
          <section className="mt-6 bg-white rounded-2xl shadow-sm p-5">
            <h2 className="font-bold text-text text-lg">Minhas aulas</h2>
            <ul className="mt-3 divide-y">
              {aulas.map((a) => (
                <li key={a.id} className="py-3 text-sm">
                  <div className="flex flex-wrap items-center gap-2">
                    <b>{a.com}</b>{a.skill && <span className="text-gray-500">· {a.skill}</span>}
                    <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${STATUS_AULA[a.status]?.cls || "bg-slate-100"}`}>{STATUS_AULA[a.status]?.txt || a.status}</span>
                  </div>
                  <div className="text-gray-600 mt-0.5">{quando(a.inicio)} · {a.duracaoMin} min</div>
                  {a.status === "sugerida" && a.sugeridoInicio && (
                    <div className="mt-2 rounded-xl bg-amber-50 border border-amber-200 p-2">
                      O professor sugeriu <b>{quando(a.sugeridoInicio)}</b>.
                      <button onClick={() => acao(a, "aceitar")} className="ml-2 bg-accent text-white font-bold rounded-lg px-3 py-1 text-xs">Aceitar</button>
                    </div>
                  )}
                  {a.status === "confirmada" && a.remarcacaoPor === "prof" && a.sugeridoInicio && (
                    <div className="mt-2 rounded-xl bg-amber-50 border border-amber-200 p-2">
                      O professor quer remarcar para <b>{quando(a.sugeridoInicio)}</b>{a.prazoResposta && <> (responda até {quando(a.prazoResposta)})</>}.
                      <button onClick={() => acao(a, "aceitar")} className="ml-2 bg-accent text-white font-bold rounded-lg px-3 py-1 text-xs">Aceitar</button>
                      <button onClick={() => acao(a, "recusar")} className="ml-1 bg-slate-100 font-bold rounded-lg px-3 py-1 text-xs">Manter o horário de antes</button>
                    </div>
                  )}
                  {a.status === "confirmada" && a.remarcacaoPor === "aluno" && a.sugeridoInicio && (
                    <div className="mt-2 text-xs text-gray-500">Você pediu para remarcar para {quando(a.sugeridoInicio)}. Aguardando o professor.</div>
                  )}
                  <div className="flex flex-wrap gap-2 mt-2">
                    {a.link && <a href={a.link} className="bg-brand text-white font-bold rounded-lg px-3 py-1.5 text-xs">Entrar na sala</a>}
                    {a.status === "confirmada" && a.podeMexer && !a.remarcacaoPor && a.remarcacoesRestantes > 0 && (
                      <RemarcarAluno aula={a} onEscolher={(inicio) => acao(a, "remarcar", inicio)} />
                    )}
                    {a.podeMexer && <button onClick={() => window.confirm("Cancelar esta aula?") && acao(a, "cancelar")} className="text-red-600 text-xs font-semibold">Cancelar</button>}
                  </div>
                </li>
              ))}
            </ul>
            <p className="text-[11px] text-gray-400 mt-2">Remarcar e cancelar: até 12 horas antes. Cada aula pode ser remarcada até 2 vezes.</p>
          </section>
        )}

        <section className="mt-6">
          <input value={skill} onChange={(e) => setSkill(e.target.value)} placeholder="Qual skill você quer desenvolver? (ex.: Excel, Inglês)"
            className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm" />
          {parceiros && parceiros.length === 0 && (
            <p className="mt-4 text-sm text-gray-500">Ainda não temos professor parceiro {skill ? `de ${skill}` : ""}. Estamos convidando novos parceiros.</p>
          )}
          <div className="grid sm:grid-cols-2 gap-4 mt-4">
            {(parceiros || []).map((p) => (
              <div key={p.id} className="bg-white rounded-2xl shadow-sm p-5 flex flex-col">
                <div className="font-bold text-text">{p.nomeExibicao}</div>
                <div className="text-xs text-gray-500">{p.formato === "escola" ? "Escola" : "Professor(a)"}{p.cidade ? ` · ${p.cidade}` : ""} · aula grátis online</div>
                <div className="flex flex-wrap gap-1 mt-2">{p.skills.map((s) => <span key={s} className="rounded-full bg-sky-100 text-sky-900 text-xs font-semibold px-2 py-0.5">{s}</span>)}</div>
                {p.sobre && <p className="text-sm text-gray-600 mt-2 line-clamp-4">{p.sobre}</p>}
                {p.vantagem && <p className="text-xs text-green-800 bg-green-50 rounded-lg px-2 py-1 mt-2">🎁 {p.vantagem}</p>}
                <button onClick={() => {
                  if (!user) { navigate(`/entrar?redirect=${encodeURIComponent("/capacitacao")}&motivo=${encodeURIComponent("Entre para pedir sua aula grátis.")}`); return; }
                  if (!ehCandidato) { setErro("Pedir aula é para contas de candidato."); return; }
                  setPedindo(p);
                }} className="mt-auto pt-3 self-start"><span className="inline-block bg-accent text-white font-bold rounded-lg px-4 py-2 text-sm">Pedir aula grátis</span></button>
              </div>
            ))}
          </div>
        </section>
      </main>

      {pedindo && <PedirAula parceiro={pedindo} skillBusca={skill} onFechar={() => setPedindo(null)}
        onPedido={() => { setPedindo(null); setAviso("Pedido enviado! O professor tem até 24 horas para responder; você recebe o aviso por e-mail."); carregarAulas(); }} />}
    </div>
  );
}

function PedirAula({ parceiro, skillBusca, onFechar, onPedido }) {
  const [livres, setLivres] = useState(null);
  const [escolha, setEscolha] = useState(null);
  const [skill, setSkill] = useState(parceiro.skills.find((s) => s.toLowerCase() === (skillBusca || "").trim().toLowerCase()) || parceiro.skills[0] || "");
  const [mensagem, setMensagem] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);
  useEffect(() => { livresDoParceiro(parceiro.id).then(setLivres).catch((e) => setErro(e.message)); }, [parceiro.id]);
  const enviar = async () => {
    setErro(""); setEnviando(true);
    try { await pedirAula({ parceiroId: parceiro.id, inicio: escolha, skill, mensagem }); onPedido(); }
    catch (e) { setErro(e.message); }
    setEnviando(false);
  };
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onFechar}>
      <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full p-5 max-h-[90vh] overflow-y-auto text-sm" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-bold text-lg text-text">Aula grátis com {parceiro.nomeExibicao}</h3>
        {parceiro.skills.length > 1 && (
          <label className="block text-xs text-gray-600 mt-3">Skill
            <select value={skill} onChange={(e) => setSkill(e.target.value)} className="w-full border rounded-lg px-2 py-1.5 mt-1">
              {parceiro.skills.map((s) => <option key={s}>{s}</option>)}
            </select>
          </label>
        )}
        <div className="text-xs text-gray-600 mt-3">Escolha um horário</div>
        {livres === null ? <p className="text-gray-400 mt-1">Carregando…</p>
          : <EscolherHorario livres={livres} valor={escolha} onChange={setEscolha} vazio="Este professor não tem horário livre nos próximos 14 dias." />}
        <label className="block text-xs text-gray-600 mt-3">Recado para o professor (opcional)
          <textarea value={mensagem} onChange={(e) => setMensagem(e.target.value)} maxLength={500} rows={2} className="w-full border rounded-lg px-2 py-1.5 mt-1"
            placeholder="Ex.: sou iniciante e preciso de Excel para vagas administrativas" />
        </label>
        {erro && <p className="text-red-600 mt-2">{erro}</p>}
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onFechar} className="bg-slate-100 font-bold rounded-lg px-4 py-2">Voltar</button>
          <button disabled={!escolha || enviando} onClick={enviar} className="bg-accent text-white font-bold rounded-lg px-4 py-2 disabled:opacity-40">{enviando ? "Enviando…" : "Pedir aula"}</button>
        </div>
        <p className="text-[11px] text-gray-400 mt-2">O professor aprova ou sugere outro horário em até 24 horas. Confirmada, você recebe o convite na agenda e o link da sala.</p>
      </div>
    </div>
  );
}

function RemarcarAluno({ aula, onEscolher }) {
  const [aberto, setAberto] = useState(false);
  const [livres, setLivres] = useState(null);
  const [escolha, setEscolha] = useState(null);
  const abrir = () => { setAberto(true); livresDoParceiro(aula.parceiroId).then(setLivres).catch(() => setLivres([])); };
  if (!aula.parceiroId) return null;
  if (!aberto) return <button onClick={abrir} className="text-xs font-semibold text-primary">Remarcar</button>;
  return (
    <div className="w-full rounded-xl border p-2">
      {livres === null ? <p className="text-gray-400 text-xs">Carregando…</p> : <EscolherHorario livres={livres} valor={escolha} onChange={setEscolha} vazio="Sem outro horário livre." />}
      <div className="flex gap-2 mt-2">
        <button disabled={!escolha} onClick={() => { onEscolher(escolha); setAberto(false); }} className="bg-accent text-white font-bold rounded-lg px-3 py-1 text-xs disabled:opacity-40">Pedir remarcação</button>
        <button onClick={() => setAberto(false)} className="text-xs">Voltar</button>
      </div>
    </div>
  );
}
